import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    successToast: ({ assetCount, shareName }: {
        assetCount: number;
        shareName: string;
    }) => string | React.ReactNode;
    undoSuccessToast: ({ assetCount, shareName }: {
        assetCount: number;
        shareName: string;
    }) => string | React.ReactNode;
    errorToast: string;
    undoErrorToast: string;
    undoLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** A message to display within a toast when assets are removed from a share */
            successToast: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ assetCount, shareName }: {
                        assetCount: number;
                        shareName: string;
                    }) => __intl__.intl().formatMessage({ id: "useRemoveAssetsFromShare.successToast?c=2qwnsa0txo6gi", defaultMessage: "{assetCount, plural, one {Asset removed from \"{shareName}\"} other {Assets removed from \"{shareName}\"}}" }, { assetCount: assetCount, shareName: shareName }));
                },
                enumerable: true,
                configurable: true
            },
            /** A message to display within a toast when assets are restored to a share */
            undoSuccessToast: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ assetCount, shareName }: {
                        assetCount: number;
                        shareName: string;
                    }) => __intl__.intl().formatMessage({ id: "useRemoveAssetsFromShare.undoSuccessToast?c=2x780c9065y0m", defaultMessage: "{assetCount, plural, one {Asset restored to \"{shareName}\"} other {Assets restored to \"{shareName}\"}}" }, { assetCount: assetCount, shareName: shareName }));
                },
                enumerable: true,
                configurable: true
            },
            /** A message to display within a toast when an error occurs during the attempted removal of assets from a share */
            errorToast: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRemoveAssetsFromShare.errorToast?c=3jeowesnre6oj", defaultMessage: "Something went wrong when removing assets from share" }));
                },
                enumerable: true,
                configurable: true
            },
            /** A message to display within a toast when an error occurs during the attempted restoration of assets to a share */
            undoErrorToast: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRemoveAssetsFromShare.undoErrorToast?c=2t2gmfop90ge9", defaultMessage: "Something went wrong when restoring assets from share" }));
                },
                enumerable: true,
                configurable: true
            },
            /** A label to display for the undo button */
            undoLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRemoveAssetsFromShare.undoLabel?c=n4og3f213zda", defaultMessage: "Undo" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
